export default "__VITE_ASSET__DBKhK9m___"